export default __webpack_public_path__ + "static/media/pivot_icon.a614bd43.jpg";